module.exports = __webpack_public_path__ + "media/images/hero_header/hero_header6-b9c425e736a99b6369484a4ad9841ae5.jpeg";